(function(){
  "use strict";
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Sticky header + scroll progress (safe if missing) ---------- */
  var header = document.getElementById("header");
  var toTop = document.getElementById("toTop");
  var progress = document.getElementById("progress");
  var lastState = null;

  function onScroll(){
    var y = window.scrollY || document.documentElement.scrollTop;
    var scrolled = y > 40;
    if (header && scrolled !== lastState){
      header.classList.toggle("scrolled", scrolled);
      lastState = scrolled;
    }
    if (toTop) toTop.classList.toggle("show", y > 600);
    if (progress){
      var max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = (max > 0 ? (y / max) * 100 : 0) + "%";
    }
  }
  window.addEventListener("scroll", onScroll, {passive:true});
  window.addEventListener("resize", onScroll);
  onScroll();

  if (toTop){
    toTop.addEventListener("click", function(){
      window.scrollTo({top:0, behavior:"smooth"});
    });
  }

  /* ---------- Mobile menu ---------- */
  var hamburger = document.getElementById("hamburger");
  var navLinks = document.getElementById("navLinks");
  function closeMenu(){
    if (!hamburger || !navLinks) return;
    hamburger.classList.remove("open");
    navLinks.classList.remove("open");
    hamburger.setAttribute("aria-expanded","false");
  }
  if (hamburger && navLinks){
    hamburger.addEventListener("click", function(){
      var open = navLinks.classList.toggle("open");
      hamburger.classList.toggle("open", open);
      hamburger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    navLinks.querySelectorAll("a").forEach(function(a){ a.addEventListener("click", closeMenu); });
    document.addEventListener("keydown", function(e){ if (e.key === "Escape") closeMenu(); });
  }

  /* ---------- Scroll reveal ---------- */
  var reveals = document.querySelectorAll(".reveal");
  if (reveals.length){
    if ("IntersectionObserver" in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting){
            entry.target.classList.add("visible");
            io.unobserve(entry.target);
          }
        });
      }, {threshold:0.12, rootMargin:"0px 0px -40px 0px"});
      reveals.forEach(function(el){ io.observe(el); });
    } else {
      reveals.forEach(function(el){ el.classList.add("visible"); });
    }
  }

  /* ---------- Product carousel arrows (only if present) ---------- */
  var carousel = document.getElementById("carousel");
  var prevBtn = document.getElementById("prevBtn");
  var nextBtn = document.getElementById("nextBtn");
  if (carousel && prevBtn && nextBtn){
    var step = 346;
    prevBtn.addEventListener("click", function(){ carousel.scrollBy({left:-step, behavior:"smooth"}); });
    nextBtn.addEventListener("click", function(){ carousel.scrollBy({left:step, behavior:"smooth"}); });
  }

  /* ---------- FAQ accordion (only if present) ---------- */
  var faqItems = document.querySelectorAll(".faq-item");
  if (faqItems.length){
    faqItems.forEach(function(item){
      var q = item.querySelector(".faq-q");
      var a = item.querySelector(".faq-a");
      if (!q || !a) return;
      q.addEventListener("click", function(){
        var isOpen = item.classList.contains("active");
        faqItems.forEach(function(other){
          other.classList.remove("active");
          var oa = other.querySelector(".faq-a");
          var oq = other.querySelector(".faq-q");
          if (oa) oa.style.maxHeight = null;
          if (oq) oq.setAttribute("aria-expanded","false");
        });
        if (!isOpen){
          item.classList.add("active");
          a.style.maxHeight = a.scrollHeight + "px";
          q.setAttribute("aria-expanded","true");
        }
      });
    });
    /* FAQ category filter (only if chips present) */
    var faqChips = document.querySelectorAll(".faq-cats .filter-chip");
    if (faqChips.length){
      faqChips.forEach(function(chip){
        chip.addEventListener("click", function(){
          faqChips.forEach(function(c){ c.classList.remove("active"); });
          chip.classList.add("active");
          var cat = chip.dataset.cat;
          faqItems.forEach(function(item){
            var show = cat === "all" || item.dataset.cat === cat;
            item.style.display = show ? "" : "none";
          });
        });
      });
    }
  }

  /* ---------- Newsletter (only if present) ---------- */
  var form = document.getElementById("newsForm");
  var email = document.getElementById("newsEmail");
  var msg = document.getElementById("newsMsg");
  if (form && email && msg){
    form.addEventListener("submit", function(e){
      var value = email.value.trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
      msg.classList.remove("ok","err");
      if (!valid){
        e.preventDefault();
        msg.textContent = "Please enter a valid email address.";
        msg.classList.add("err");
        email.focus();
        return;
      }
      /* Valid — let Shopify handle the real signup, the success message is
         rendered back by Liquid after the redirect. */
    });
    if (msg.textContent.trim() !== "") msg.classList.add("ok");
  }

  /* ---------- Contact form (only if present) ---------- */
  var contactForm = document.getElementById("contactForm");
  if (contactForm){
    var cMsg = document.getElementById("contactMsg");
    if (cMsg && cMsg.textContent.trim() !== "") cMsg.classList.add("ok");
    contactForm.addEventListener("submit", function(e){
      var valid = true;
      var name = document.getElementById("cName");
      var cEmail = document.getElementById("cEmail");
      var message = document.getElementById("cMessage");
      [name, cEmail, message].forEach(function(field){
        if (!field) return;
        var wrap = field.closest(".field");
        var empty = field.value.trim() === "";
        var badEmail = field === cEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(field.value.trim());
        if (wrap) wrap.classList.toggle("invalid", empty || badEmail);
        if (empty || badEmail) valid = false;
      });
      if (!valid){
        e.preventDefault();
        if (cMsg){ cMsg.textContent = "Please fill in all fields correctly."; cMsg.classList.remove("ok"); cMsg.classList.add("err"); }
        return;
      }
      /* Valid — let Shopify send the message; the confirmation is rendered
         back by Liquid after the redirect. */
    });
  }

  /* ---------- Smooth anchor scrolling with header offset (same-page only) ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function(link){
    link.addEventListener("click", function(e){
      var id = this.getAttribute("href");
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var offset = (header ? header.offsetHeight : 0) + 12;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({top: top, behavior: "smooth"});
    });
  });

  /* ---------- Animated counters ---------- */
  function animateCount(el){
    var target = parseFloat(el.dataset.count);
    var decimals = parseInt(el.dataset.decimals || "0", 10);
    var suffix = el.dataset.suffix || "";
    var useIN = el.dataset.format === "in";
    var duration = 1600;
    var start = null;
    function frame(ts){
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      var text = decimals ? val.toFixed(decimals) : Math.round(val).toString();
      if (useIN) text = Number(text).toLocaleString("en-IN");
      el.textContent = text + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  var counts = document.querySelectorAll(".count");
  if (counts.length && !reducedMotion && "IntersectionObserver" in window){
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          animateCount(entry.target);
          cio.unobserve(entry.target);
        }
      });
    }, {threshold:0.6});
    counts.forEach(function(el){ cio.observe(el); });
  }

  /* ---------- Sparkles in hero (only if hero exists) ---------- */
  var hero = document.getElementById("home") || document.querySelector(".hero");
  if (!reducedMotion && hero){
    for (var i = 0; i < 14; i++){
      var s = document.createElement("span");
      s.className = "sparkle";
      s.textContent = "✦";
      s.style.left = (4 + Math.random() * 92) + "%";
      s.style.top = (6 + Math.random() * 84) + "%";
      s.style.setProperty("--tw", (3 + Math.random() * 4).toFixed(1) + "s");
      s.style.setProperty("--td", (Math.random() * 5).toFixed(1) + "s");
      s.style.setProperty("--ts", (8 + Math.random() * 10).toFixed(0) + "px");
      hero.appendChild(s);
    }
  }

  /* ---------- 3D tilt + parallax (fine pointers only, only where elements exist) ---------- */
  if (!reducedMotion && window.matchMedia("(hover:hover) and (pointer:fine)").matches){
    document.querySelectorAll(".product-card").forEach(function(card){
      var media = card.querySelector(".product-media");
      if (!media) return;
      card.addEventListener("mousemove", function(e){
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        media.style.transform = "rotateY(" + (x * 7) + "deg) rotateX(" + (-y * 7) + "deg)";
      });
      card.addEventListener("mouseleave", function(){
        media.style.transform = "rotateY(0deg) rotateX(0deg)";
      });
    });

    var heroArt = document.querySelector(".hero-art");
    if (heroArt && hero){
      var px = 0, py = 0, tx = 0, ty = 0, rafId = null;
      var lerpLoop = function(){
        px += (tx - px) * 0.06;
        py += (ty - py) * 0.06;
        heroArt.style.transform = "translate(" + px.toFixed(2) + "px," + py.toFixed(2) + "px)";
        if (Math.abs(tx - px) > 0.1 || Math.abs(ty - py) > 0.1){
          rafId = requestAnimationFrame(lerpLoop);
        } else { rafId = null; }
      };
      hero.addEventListener("mousemove", function(e){
        if (!heroArt.classList.contains("visible") && !heroArt.classList.contains("reveal")) return;
        heroArt.style.transition = "none";
        var r = hero.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 22;
        ty = ((e.clientY - r.top) / r.height - 0.5) * 16;
        if (!rafId) rafId = requestAnimationFrame(lerpLoop);
      });
      hero.addEventListener("mouseleave", function(){
        tx = 0; ty = 0;
        if (!rafId) rafId = requestAnimationFrame(lerpLoop);
      });
    }
  }

  /* =====================================================================
     CART — Shopify AJAX cart, works across every page.
     Header count, add-to-cart buttons, quantity steppers and the cart page
     are all wired to the real Shopify cart (/cart/add.js, /cart/change.js).
  ===================================================================== */
  var moneyFormat = (window.DG && window.DG.moneyFormat) || "₹{{amount_no_decimals}}";

  function formatMoney(cents){
    var value = cents / 100;
    var out = moneyFormat;
    function withComma(n, decimals){
      return Number(n.toFixed(decimals)).toLocaleString("en-IN", {
        minimumFractionDigits: decimals, maximumFractionDigits: decimals
      });
    }
    out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma(value, 0));
    out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(value, 2));
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withComma(value, 0));
    out = out.replace(/\{\{\s*amount\s*\}\}/g, withComma(value, 2));
    return out;
  }

  function updateCartCount(count){
    document.querySelectorAll(".cart-count").forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? "flex" : "none";
    });
  }

  function refreshCartCount(){
    fetch("/cart.js", {headers:{"Accept":"application/json"}, credentials:"same-origin"})
      .then(function(r){ return r.json(); })
      .then(function(cart){ updateCartCount(cart.item_count); })
      .catch(function(){});
  }

  function showToast(text){
    var toast = document.getElementById("toast");
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add("show");
    clearTimeout(toast._t);
    toast._t = setTimeout(function(){ toast.classList.remove("show"); }, 2400);
  }

  /* Add-to-cart buttons on any page (product cards, product detail) */
  document.querySelectorAll("[data-add-to-cart]").forEach(function(btn){
    /* Buttons inside a real <form> (photo upload) submit natively — skip. */
    if (btn.getAttribute("type") === "submit") return;

    btn.addEventListener("click", function(e){
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      if (!variantId){
        if (btn.dataset.url) window.location.href = btn.dataset.url;
        return;
      }
      var qtyInput = document.getElementById("qtyInput");
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var properties = {};
      document.querySelectorAll("[data-line-property]").forEach(function(input){
        if (input.value) properties[input.dataset.lineProperty] = input.value;
      });

      var payload = {items:[{id: variantId, quantity: qty}]};
      if (Object.keys(properties).length) payload.items[0].properties = properties;

      var original = btn.textContent;
      fetch("/cart/add.js", {
        method: "POST",
        headers: {"Content-Type":"application/json", "Accept":"application/json"},
        credentials: "same-origin",
        body: JSON.stringify(payload)
      })
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, data:d}; }); })
        .then(function(res){
          if (!res.ok){
            showToast((res.data && res.data.description) || "Could not add to cart");
            return;
          }
          showToast((btn.dataset.name || "Item") + " added to cart");
          btn.classList.add("added");
          btn.textContent = "Added ✓";
          setTimeout(function(){ btn.classList.remove("added"); btn.textContent = original; }, 1600);
          refreshCartCount();
        })
        .catch(function(){ showToast("Could not add to cart"); });
    });
  });

  /* Product detail quantity stepper (only if present) */
  var qtyInput = document.getElementById("qtyInput");
  var qtyMinus = document.getElementById("qtyMinus");
  var qtyPlus = document.getElementById("qtyPlus");
  if (qtyInput && qtyMinus && qtyPlus){
    qtyMinus.addEventListener("click", function(){
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value,10) || 1) - 1);
    });
    qtyPlus.addEventListener("click", function(){
      qtyInput.value = (parseInt(qtyInput.value,10) || 1) + 1;
    });
  }

  /* Product detail image gallery (only if present) */
  var mainImg = document.getElementById("mainProductImg");
  var thumbs = document.querySelectorAll(".thumb");
  if (mainImg && thumbs.length){
    thumbs.forEach(function(thumb){
      thumb.addEventListener("click", function(){
        thumbs.forEach(function(t){ t.classList.remove("active"); });
        thumb.classList.add("active");
        mainImg.src = thumb.dataset.full || thumb.src;
      });
    });
  }

  /* Cart page — rows are rendered by Liquid; these wire the controls */
  function changeCartLine(line, quantity){
    fetch("/cart/change.js", {
      method: "POST",
      headers: {"Content-Type":"application/json", "Accept":"application/json"},
      credentials: "same-origin",
      body: JSON.stringify({line: line, quantity: quantity})
    })
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.reload(); })
      .catch(function(){ window.location.reload(); });
  }

  document.querySelectorAll("[data-remove-line]").forEach(function(btn){
    btn.addEventListener("click", function(){ changeCartLine(btn.dataset.removeLine, 0); });
  });
  document.querySelectorAll("[data-minus-line]").forEach(function(btn){
    btn.addEventListener("click", function(){
      changeCartLine(btn.dataset.minusLine, Math.max(0, parseInt(btn.dataset.qty, 10) - 1));
    });
  });
  document.querySelectorAll("[data-plus-line]").forEach(function(btn){
    btn.addEventListener("click", function(){
      changeCartLine(btn.dataset.plusLine, parseInt(btn.dataset.qty, 10) + 1);
    });
  });

  /* Initial header count comes from Liquid; just apply the show/hide rule */
  document.querySelectorAll(".cart-count").forEach(function(el){
    var n = parseInt(el.textContent, 10) || 0;
    el.style.display = n > 0 ? "flex" : "none";
  });

  /* ---------- Drag Before/After compare sliders (only if present) ---------- */
  document.querySelectorAll("[data-compare]").forEach(function(slider){
    var clip = slider.querySelector(".compare-clip");
    var handle = slider.querySelector(".compare-handle");
    var layer = clip ? clip.querySelector(".compare-layer") : null;
    if (!clip || !handle || !layer) return;

    function setWidth(){ layer.style.width = slider.offsetWidth + "px"; }
    setWidth();
    window.addEventListener("resize", setWidth);

    var dragging = false;
    function move(clientX){
      var rect = slider.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      clip.style.width = pct + "%";
      handle.style.left = pct + "%";
    }
    slider.addEventListener("pointerdown", function(e){
      dragging = true;
      move(e.clientX);
      if (slider.setPointerCapture) slider.setPointerCapture(e.pointerId);
    });
    slider.addEventListener("pointermove", function(e){ if (dragging) move(e.clientX); });
    slider.addEventListener("pointerup", function(){ dragging = false; });
    slider.addEventListener("pointerleave", function(){ dragging = false; });
  });

  /* ---------- Lightbox (only if present) ---------- */
  var lightbox = document.getElementById("lightbox");
  if (lightbox){
    var lightboxImg = lightbox.querySelector("img");
    var lightboxVideo = document.getElementById("lightboxVideo");
    var lightboxEmbed = document.getElementById("lightboxEmbed");
    var lightboxClose = lightbox.querySelector(".lightbox-close");

    function resetLightboxMedia(){
      if (lightboxImg){ lightboxImg.style.display = "none"; lightboxImg.removeAttribute("src"); }
      if (lightboxVideo){
        lightboxVideo.pause();
        lightboxVideo.style.display = "none";
        lightboxVideo.removeAttribute("src");
        lightboxVideo.removeAttribute("poster");
        lightboxVideo.load();
      }
      if (lightboxEmbed){ lightboxEmbed.style.display = "none"; lightboxEmbed.removeAttribute("src"); }
    }

    /* YouTube / Vimeo URLs become their embed players; anything else is a file. */
    function toEmbedUrl(url){
      var m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
      if (m) return "https://www.youtube.com/embed/" + m[1] + "?autoplay=1&rel=0&playsinline=1";
      m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (m) return "https://player.vimeo.com/video/" + m[1] + "?autoplay=1";
      return null;
    }

    document.querySelectorAll("[data-lightbox]").forEach(function(el){
      el.addEventListener("click", function(){
        var video = el.dataset.lightboxVideo;
        var poster = el.dataset.lightbox;
        resetLightboxMedia();

        if (video){
          var embed = toEmbedUrl(video);
          if (embed && lightboxEmbed){
            lightboxEmbed.src = embed;
            lightboxEmbed.style.display = "block";
          } else if (lightboxVideo){
            if (poster) lightboxVideo.poster = poster;
            lightboxVideo.src = video;
            lightboxVideo.style.display = "block";
            var playing = lightboxVideo.play();
            if (playing && playing.catch) playing.catch(function(){});
          } else {
            return;
          }
        } else {
          if (!poster || !lightboxImg) return;
          lightboxImg.src = poster;
          lightboxImg.style.display = "block";
        }
        lightbox.classList.add("show");
      });
    });
    function closeLightbox(){ lightbox.classList.remove("show"); resetLightboxMedia(); }
    if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);
    lightbox.addEventListener("click", function(e){ if (e.target === lightbox) closeLightbox(); });
    document.addEventListener("keydown", function(e){ if (e.key === "Escape") closeLightbox(); });
  }

})();